// extracted by mini-css-extract-plugin
export default {"root":"styles_root__O0923","layer":"styles_layer__zlVMV","fon":"styles_fon__RHubT"};